module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAASFBMVEUAAACOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpOOjpPEsrClAAAAF3RSTlMA7fEQ6zAgX/MqhPYW0K+rC/divE7LmVp54v8AAADESURBVDjL5ZTLDoMgEEWZYcrDUsVHO///pwWVUEM6cdnYs1HjyQ0s7lWXww+EAIB9eh8QDiANvnid4w0XlXLc4LrduzPfARHdnL56hwcg/11NnzLIBq11VJmoDwRLKdPniOQFJRCSmU8PPE5KZBoZ0gMZl5vIkpQ18QTwxyIZJWLoR8XXY2M2smi5YEUxUvEoimL3ESiKQ/Ge9TLI4Bsx2J2QWwWMZ6tA58tV6mr0F0ypax2ASjsAdVIkXHcYqUo7UlfjDe4QKoTBDuzLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_pay_bank.png
// module id = GuFU
// module chunks = 21